module.exports = __webpack_public_path__ + "static/img/enterprise-hope-bg.d0d522b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/homepage/enterprise-hope-bg.png
// module id = wXQy
// module chunks = 4